import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/system/Stack";
import Container from "@mui/material/Container";
import Surtitle from "@project/components/Surtitle";
const NumbersPart = (props) => {
    const { page } = props;
    const { contents } = page || {};
    const { titleNumbersPart, subtitleNumbersPart, horizontalInfos, dynamicNumbersPart, } = contents;
    return (_jsx(Box, { sx: {
            backgroundColor: "background.header",
            py: { xs: "60px", sm: "120px" },
            backgroundImage: "url('/fond-waves.png')",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
        }, children: _jsx(Container, { sx: { maxWidth: "1208px !important" }, children: _jsxs(Stack, { spacing: 5, children: [_jsxs(Stack, { spacing: 2, children: [_jsx(Surtitle, { title: titleNumbersPart, contrast: true }), _jsx(Typography, { component: "p", variant: "h3", sx: { color: "primary.contrastText" }, children: subtitleNumbersPart })] }), _jsx(Box, { children: horizontalInfos }), _jsx(Box, { children: dynamicNumbersPart })] }) }) }));
};
export default NumbersPart;
